import { render, staticRenderFns } from "./logisticWorkbench.vue?vue&type=template&id=bb45966e&"
import script from "./logisticWorkbench.vue?vue&type=script&lang=js&"
export * from "./logisticWorkbench.vue?vue&type=script&lang=js&"
import style0 from "./logisticWorkbench.vue?vue&type=style&index=0&id=bb45966e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports